import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Card, CardContent, Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      minWidth: 180,
      height: '100%',
      marginTop: theme.spacing(4)
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(4)
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    title: {
      fontSize: '12pt',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      color: '#4B4B4B',
      fontWeight: 400
    },
    number: {
      fontSize: '48pt',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontWeight: 700,
      textAlign: 'center'
    }
  })
)
export default function CardWidgetSkeleton (): JSX.Element {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <CardContent>
        <div className={classes.header}>
          <Skeleton width="60%" height={32} />
          <Skeleton variant="circle" width={32} height={32} />
        </div>
        <Typography className={`${classes.number}`}>
          <Skeleton />
        </Typography>
      </CardContent>
    </Card>
  )
}
